import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { StickyHeaderNavigation } from '@/components'
import { BaseText, BaseView } from '@/components/base'

export const ValidationByFeatureHeader: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleBackPress = () => {
    // Navigate to dashboard instead of going back to avoid redirect loop
    navigate('/dashboard')
  }

  return (
    <>
      <StickyHeaderNavigation title="" onBackPress={handleBackPress} />

      <BaseView px={12}>
        <BaseText
          style={{
            marginTop: 16,
            fontSize: 28,
            fontWeight: '600',
          }}
          color="label.white"
        >
          {t('translation:validationsByFeature.title')}
        </BaseText>
      </BaseView>
    </>
  )
}
